import React, { useEffect, useRef } from "react";
import keycloak from "../APIs/keycloak";
import { useCurrentUser } from "../APIs/UserContext";
import AdminTabs from "./AdminTabs";

export default function AdminRoute() {
  const { currentUser, loading } = useCurrentUser();
  const loginStarted = useRef(false);

  useEffect(() => {
    if (loading || keycloak?.authenticated || loginStarted.current) return;

    loginStarted.current = true;
    try {
      keycloak.login({
        redirectUri: `${window.location.origin}/admin`,
      });
    } catch (err) {
      console.error("Unable to start admin login:", err);
      window.location.href = "/";
    }
  }, [loading]);

  if (loading || (!keycloak?.authenticated && loginStarted.current)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
          <p className="text-gray-700">Opening admin login...</p>
        </div>
      </div>
    );
  }

  if (!keycloak?.authenticated) {
    return null;
  }

  if (!currentUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
          <p className="text-red-600 mb-2">Unable to load admin account.</p>
          <button
            type="button"
            className="text-blue-600 font-medium"
            onClick={() => (window.location.href = "/")}
          >
            Return home
          </button>
        </div>
      </div>
    );
  }

  if (currentUser.userType !== "ADMIN") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
          <p className="text-red-600 mb-2">Admin access required.</p>
          <p className="text-sm text-gray-600 mb-4">
            This account does not have admin permissions.
          </p>
          <button
            type="button"
            className="text-blue-600 font-medium"
            onClick={() => (window.location.href = "/")}
          >
            Return home
          </button>
        </div>
      </div>
    );
  }

  return <AdminTabs />;
}
